import React, { useState } from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import { Notifications, NotificationsOff } from '@mui/icons-material';
import api from '../services/api';

const WatchButton = ({ auctionId, isWatching: initialWatching, variant = 'button' }) => {
  const [isWatching, setIsWatching] = useState(initialWatching);
  const [loading, setLoading] = useState(false);

  const handleToggleWatch = async () => {
    setLoading(true);

    try {
      if (isWatching) {
        await api.delete(`/auctions/${auctionId}/watch`);
        setIsWatching(false);
      } else {
        await api.post(`/auctions/${auctionId}/watch`);
        setIsWatching(true);
      }
    } catch (err) {
      console.error('Failed to toggle watch:', err);
    } finally {
      setLoading(false);
    }
  };

  if (variant === 'icon') {
    return (
      <Tooltip title={isWatching ? 'Stop watching' : 'Watch auction'}>
        <IconButton onClick={handleToggleWatch} disabled={loading} color={isWatching ? 'primary' : 'default'}>
          {isWatching ? <Notifications /> : <NotificationsOff />}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Button
      variant={isWatching ? 'contained' : 'outlined'}
      startIcon={isWatching ? <Notifications /> : <NotificationsOff />}
      onClick={handleToggleWatch}
      disabled={loading}
    >
      {isWatching ? 'Watching' : 'Watch Auction'}
    </Button>
  );
};

export default WatchButton;
